import React from 'react';
import { Illustration } from './ImageQuote';
import './ui.css';

// Says what is empty and what to do next. An optional photograph (from
// src/data/learningImagery.js) sits beside the text on wide screens.
export default function EmptyState({ title, children, actionLabel, onAction, image }) {
  return (
    <div className={`empty-state${image ? ' empty-state--with-image' : ''}`}>
      {image && <Illustration image={image} className="empty-state-image" />}
      <div className="empty-state-body">
        <h3 className="empty-state-title">{title}</h3>
        {children && <p className="empty-state-text">{children}</p>}
        {actionLabel && (
          <button type="button" className="btn btn-primary" onClick={onAction}>{actionLabel}</button>
        )}
      </div>
    </div>
  );
}
